module.exports = __webpack_public_path__ + "img/hook_KONDOTEC_LS_2.c43be508.png";